import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchObtenerWebDestino = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/api/comunicacion/webs-destino/${id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const fetchObtenerWebsDestino = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/comunicacion/webs-destino`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const fetchCrearWebDestino = async (webDestinoData) => {
    try {
        const response = await axios.post(`${API_URL}/api/comunicacion/webs-destino`, webDestinoData, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const fetchActualizarWebDestino = async (id, webDestinoData) => {
    try {
        const response = await axios.put(`${API_URL}/api/comunicacion/webs-destino/${id}`, webDestinoData, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const fetchEliminarWebDestino = async (id) => {
    try {
        const response = await axios.delete(`${API_URL}/api/comunicacion/webs-destino/${id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};
